import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

var Col = function Col(props) {
  var colClass = classNames(props.span ? "col-".concat(props.span) : "col", props.sm ? "col-".concat(props.sm, "--sm") : "", props.xs ? "col-".concat(props.xs, "--xs") : "", props.md ? "col-".concat(props.md, "--md") : "", props.offset ? "col-offset-".concat(props.offset) : "", {
    first: props.first,
    last: props.last
  }, props.className);
  return React.createElement("div", {
    className: colClass
  }, props.children);
};

Col.propTypes = {
  span: PropTypes.number,
  offest: PropTypes.number,
  className: PropTypes.string,
  sm: PropTypes.number,
  md: PropTypes.number,
  xs: PropTypes.number
};
Col.defaultProps = {
  span: null,
  sm: null,
  md: null,
  xs: null,
  className: ''
};
Col.displayName = 'Col';
export default React.memo(Col);